import { render, staticRenderFns } from "./RolledSection.vue?vue&type=template&id=3a61ede4&"
import script from "./RolledSection.vue?vue&type=script&lang=js&"
export * from "./RolledSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports